import { render, staticRenderFns } from "./roomWatcherNoPicnew.vue?vue&type=template&id=66ba71a2&"
import script from "./roomWatcherNoPicnew.vue?vue&type=script&lang=js&"
export * from "./roomWatcherNoPicnew.vue?vue&type=script&lang=js&"
import style0 from "./roomWatcherNoPicnew.vue?vue&type=style&index=0&id=66ba71a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports